import { FC, useEffect } from "react";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentHolidayPackage, setHolidayPackage } from "application/features/holidayPackage/holidayPackageSlice";
import { Link, useNavigate } from "react-router-dom";
import Label from "components/Label/Label";
import { useTranslation } from "react-i18next";

export interface AddHolidayPackage5aProps { }

const PageAddHolidayPackage5a
: FC<AddHolidayPackage5aProps> = () => {

    const { t, ready } = useTranslation("translation");
    const holidayPackage = useSelector(selectCurrentHolidayPackage);
    const dispatch = useDispatch();

    const handleUpdateHolidayPackage = async (field: string, value: any) => {
        dispatch(setHolidayPackage({ ...holidayPackage, [field]: value }))
    };

    const _updateDefaultFields = async () => {
        dispatch(setHolidayPackage({ 
            ...holidayPackage, 
            defined_guests: holidayPackage?.defined_guests? holidayPackage.defined_guests : undefined
        }))
    }

    function nextPageCondition() {
        return holidayPackage?.defined_guests && holidayPackage.defined_guests > 0;
    }

    useEffect(() => {
        _updateDefaultFields();
    }, []);

    if (!ready) return null;

    return (
        <CommonLayout
            index="05"
            backtHref={"/host/new-holiday-package/add-listing-4"}
            nextHref={"/host/new-holiday-package/add-listing-6"}
            canGoNext={nextPageCondition()}
        >
        <>
            <h2 className="text-2xl font-semibold">{t("translation:components.holidayPackageForm.page5a.title")}</h2>
            <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
            {/* FORM */}
            <div className="space-y-8">
                {/* ITEM */}
                <FormItem
                    label={t("translation:components.holidayPackageForm.page5a.form.peopleNumberLabel")}
                >
                    <p className="text-sm font-medium text-neutral-500 dark:text-neutral-300 pb-2">{t("translation:components.holidayPackageForm.page5a.form.peopleNumberDescription")}</p>
                    <Input
                        type="number"
                        min={1}
                        defaultValue={holidayPackage?.defined_guests}
                        onChange={(e) => handleUpdateHolidayPackage("defined_guests", e.target.value)}
                        placeholder={t("translation:components.holidayPackageForm.page5a.form.peopleNumberPlaceholder")}
                    >
                    </Input>
                </FormItem>
            </div>
        </>
        </CommonLayout >
    );
};

export default PageAddHolidayPackage5a;